import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main__bg is-pc" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "main__inner inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mv-avatar2 is-pc" }),
  /*#__PURE__*/_createElementVNode("div", { class: "main__body" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mv__lead" }, [
      /*#__PURE__*/_createElementVNode("span", null, "AR/VR"),
      /*#__PURE__*/_createTextVNode("で、熱中を価値に変える。")
    ]),
    /*#__PURE__*/_createElementVNode("h1", { class: "mv__ttl" }, [
      /*#__PURE__*/_createTextVNode(" メタバースで"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", null, "驚きと感動"),
      /*#__PURE__*/_createTextVNode("を"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("生み出そう。 ")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      class: "cta__button mv__button",
      href: "./account_register",
      target: "_blank"
    }, "今すぐ無料で体験する")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "main__video" }, [
    /*#__PURE__*/_createElementVNode("video", {
      id: "myVideo",
      autoplay: "",
      muted: "",
      loop: "",
      playsinline: ""
    }, [
      /*#__PURE__*/_createElementVNode("source", {
        src: "/public/home_page/img/mv.MP4",
        type: "video/mp4"
      }),
      /*#__PURE__*/_createTextVNode(" Your browser does not support HTML5 video. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mv-avatar1" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}